(() => {
  const preview = document.body.dataset.preview === 'true';
  const root = document.body.dataset.root || '/';
  const key = 'zoey-glove-preview-v2';
  const labels = JSON.parse(document.querySelector('#zm-strings')?.textContent || '{}');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: preview ? 'USD' : document.body.dataset.currency || 'USD' }).format(cents / 100);
  const drawer = document.querySelector('#ZoeyCart');
  let lastFocus = null;
  let items = [];
  try { items = JSON.parse(sessionStorage.getItem(key) || '[]').filter(item => typeof item.id === 'string' && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 20 && Number.isFinite(item.price)); } catch { items = []; }
  const announce = text => { const status = document.querySelector('[data-zm-status]'); if (status) status.textContent = text; };
  const save = () => { try { sessionStorage.setItem(key, JSON.stringify(items)); } catch {} };
  const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  const renderPreview = () => {
    if (!preview) return;
    const count = items.reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
    document.querySelectorAll('[data-cart-content]').forEach(container => {
      const target = container.querySelector('[data-preview-items]');
      if (!target) return;
      target.replaceChildren();
      for (const item of items) {
        const row = element('article', 'zm-cart-item');
        const image = element('img', 'zm-cart-item__image');
        image.src = item.image; image.alt = item.title; image.width = 160; image.height = 160;
        const details = element('div');
        details.append(element('strong', 'zm-cart-item__title', item.title), element('p', '', item.label));
        const quantity = element('div', 'zm-cart-item__quantity');
        const minus = element('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', `${labels.decrease}: ${item.label}`); minus.dataset.cartId = item.id; minus.dataset.cartDelta = '-1';
        const value = element('span', '', String(item.quantity)); value.setAttribute('aria-label', `${labels.quantity}: ${item.quantity}`);
        const plus = element('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', `${labels.increase}: ${item.label}`); plus.dataset.cartId = item.id; plus.dataset.cartDelta = '1'; plus.disabled = item.quantity >= 20;
        quantity.append(minus, value, plus);
        const remove = element('button', 'zm-cart-item__remove', labels.remove); remove.type = 'button'; remove.dataset.cartId = item.id; remove.dataset.cartRemove = 'true'; remove.setAttribute('aria-label', `${labels.remove}: ${item.label}`);
        details.append(quantity, remove); row.append(image, details, element('strong', '', money(item.price * item.quantity))); target.append(row);
      }
      const empty = container.querySelector('[data-cart-empty]'); if (empty) empty.hidden = count > 0;
      const summary = container.querySelector('[data-cart-summary]'); if (summary) summary.hidden = count === 0;
      const total = container.querySelector('[data-cart-total]'); if (total) total.textContent = money(items.reduce((sum, item) => sum + item.price * item.quantity, 0));
    });
  };
  const openCart = trigger => {
    if (!drawer) return;
    lastFocus = trigger || document.activeElement;
    renderPreview();
    if (!drawer.open) drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const closeCart = () => { if (!drawer) return; drawer.close(); };
  drawer?.addEventListener('close', () => { document.documentElement.style.overflow = ''; lastFocus?.focus?.(); });
  drawer?.addEventListener('click', event => { if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right) closeCart(); } });
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.matches('[data-open-cart]')) { event.preventDefault(); openCart(target); }
    if (target.matches('[data-close-cart]')) closeCart();
    if (target.dataset.cartId && preview) {
      const item = items.find(entry => entry.id === target.dataset.cartId); if (!item) return;
      const container = target.closest('[data-cart-content]');
      const action = target.dataset.cartRemove ? 'remove' : target.dataset.cartDelta;
      item.quantity = target.dataset.cartRemove ? 0 : Math.min(20, item.quantity + Number(target.dataset.cartDelta));
      items = items.filter(entry => entry.quantity > 0); save(); renderPreview();
      const nextFocus = Array.from(container?.querySelectorAll('[data-cart-id]') || []).find(button => button.dataset.cartId === item.id && (action === 'remove' ? false : button.dataset.cartDelta === action));
      (nextFocus || container?.querySelector('a,button:not([disabled])') || drawer?.querySelector('[data-close-cart]'))?.focus();
      announce(labels.updated);
    }
    const mobile = target.closest('.zm-mobile-menu'); if (mobile && target.tagName === 'A') mobile.removeAttribute('open');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const mobile = document.querySelector('.zm-mobile-menu[open]');
    if (mobile) { mobile.removeAttribute('open'); mobile.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', event => {
    const mobile = document.querySelector('.zm-mobile-menu[open]');
    if (mobile && !mobile.contains(event.target)) mobile.removeAttribute('open');
  });
  class ZoeyProduct extends HTMLElement {
    controller;
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const form = this.querySelector('form'); if (!form) return;
      form.addEventListener('submit', this.submit, { signal: this.controller.signal });
      form.addEventListener('change', () => { const choice=form.querySelector('input[name="id"]:checked'); const submit=form.querySelector('[type="submit"]'); if(submit) submit.disabled=!choice || choice.disabled; }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    submit = async event => {
      const form = event.currentTarget;
      if (!form.checkValidity()) return;
      event.preventDefault();
      const choice = form.querySelector('input[name="id"]:checked'); if (!choice || choice.disabled) return;
      const quantity = Math.max(1, Math.min(20, Number(form.elements.quantity.value) || 1));
      const button = form.querySelector('[type="submit"]'); const status = this.querySelector('[data-product-status]');
      if (this.dataset.preview === 'true') {
        const existing = items.find(item => item.id === choice.value);
        if (existing) existing.quantity = Math.min(20, existing.quantity + quantity);
        else items.push({ id: choice.value, quantity, price: Number(choice.dataset.price), label: choice.dataset.label, title: this.dataset.title, image: this.dataset.image });
        save(); renderPreview(); if (status) status.textContent = this.dataset.added; announce(this.dataset.added); openCart(button); return;
      }
      button.disabled = true; if (status) status.textContent = '';
      try {
        const data = new FormData(form);
        const response = await fetch(new URL(`${root}cart/add.js`, location.origin), { method: 'POST', body: data, headers: { Accept: 'application/json' }, signal: this.controller.signal });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        location.assign(new URL(`${root}cart`, location.origin).href);
      } catch (error) { if (error.name !== 'AbortError' && status) status.textContent = error.message || this.dataset.error; }
      finally { button.disabled = false; }
    };
  }
  class ZoeyGallery extends HTMLElement {
    controller;
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const image = this.querySelector('.zm-gallery__image'); const dialog = this.querySelector('dialog'); const zoom = this.querySelector('[data-zoom-image]');
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-gallery-src]');
        if (thumbnail && image) { image.src = thumbnail.dataset.gallerySrc; image.removeAttribute('srcset'); image.alt = thumbnail.dataset.galleryAlt; this.querySelectorAll('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail))); }
        if (event.target.closest('[data-zoom]') && dialog && image && zoom) { zoom.src = image.currentSrc || image.src; zoom.alt = image.alt; dialog.showModal(); }
        if (event.target.closest('[data-close-zoom]')) dialog?.close();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('zm-product')) customElements.define('zm-product', ZoeyProduct);
  if (!customElements.get('zm-gallery')) customElements.define('zm-gallery', ZoeyGallery);
  document.addEventListener('shopify:section:load', renderPreview);
  renderPreview();
})();
